import React from 'react';
import Basic from './Basic';
import Main from './Main';
import ModelAccordion from "./components/ModelAccordion";
import {withRouter} from 'react-router-dom';
import {inject, observer} from 'mobx-react';
import classNames from "classnames";
import HttpClient from 'services/HttpClient';
const GET_WORKSHOP = '/api/v1/workshops/';
const GET_MODULE = "/api/v1/modules/";

@withRouter
@inject('workshopDetails')
@inject("user")
@observer
export default class RegularDetails extends React.Component {
  state = {
    description: ''
  };

  componentDidMount = () => {
    let id= this.props.match.params.id;
    new HttpClient().get(GET_WORKSHOP + id).then(data => {
      this.props.workshopDetails.setWorkshop(data.body.data.workshop)
    })
  };

  componentWillUnmount = () => {
    this.props.workshopDetails.clearWorkshop();
    window.removeEventListener("beforeunload", this.clearStorage);
  };

  clearStorage = () => {
    if(localStorage.getItem("haveAccess") === "2")
      localStorage.removeItem('haveAccess');
  }

  getModuleDescription = index => {

    new HttpClient().get(`${GET_MODULE}${this.props.workshopDetails.workshop.modules[index].id}`).then(response => {
      this.setState({description: response.body.module.description || ''});
    });
  }

  render() {
    let fullHeight = false;
    if (this.props.user.getUser())
      if (
        this.props.user.getUser().role === "admin" ||
        this.props.workshopDetails.workshop.access_type === "owner" ||
        this.props.workshopDetails.workshop.access_type === "purchased" ||
        localStorage.getItem("haveAccess")
      )
        fullHeight = true;

    return (
      <main className={classNames("main-content purchased", {
        customOnlineWorkshop: !fullHeight
      })}>
        <div className="container-fluid ">
          <div className="row regular-workshop">
           <Basic getModuleDescription={this.getModuleDescription} />
           {/* <Main/> */}

           <div className="col-12 col-md-9 pull-md-3">
              <div className="regular-workshop-content">
                <div className="workshop-module gutter">
                  <div className="accordion">
                    <div>
                      <ModelAccordion
                        type="workshop"
                        getModuleDescription={this.getModuleDescription}
                      />
                      {(this.props.workshopDetails.workshop.access_type !==
                        "not_purchased" &&
                      this.props.workshopDetails.workshop.access_type !==
                        "pending") || this.props.workshopDetails.workshop.access_type == "owner" ||
                        localStorage.getItem("haveAccess")
                        ? (this.props.workshopDetails.workshop.modules || []).map(
                            (el, index) => (
                              <ModelAccordion
                                type="module"
                                moduleType={el.module_type}
                                key={index}
                                index={index}
                                description={this.state.description}
                                getModuleDescription={this.getModuleDescription}
                                questions_length={el.questions ? el.questions.length : 0}
                                is_hidden={el.is_hidden}
                              />
                            )
                          )
                        : null}
                      {this.props.location.pathname.includes("admin")
                        ? (this.props.workshopDetails.workshop.modules || []).map(
                            (el, index) => (
                              <ModelAccordion
                                type="module"
                                moduleType={el.module_type}
                                description={this.state.description}
                                key={index}
                                index={index}
                                questions_length={el.questions ? el.questions.length : 0}
                                getModuleDescription={this.getModuleDescription}
                                is_hidden={el.is_hidden}
                              />
                            ))
                        : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/regular_details/RegularDetails.jsx